import React, { useEffect, useState, useCallback, memo } from 'react';
import { Box, Typography, TextField, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { useNewAppointment } from '../context';
import useStyles from './styles';
import { convertObjToArr, convertArrToObj } from '../../../../utils';

const Informations = () => {
  const classes = useStyles();
  const { newAppointmentInfos, setNewAppointmentInfos } = useNewAppointment();
  const history = useHistory();
  const [informationsValues, setInformationsValues] = useState({
    contact: {
      value: '',
      error: false,
    },
    mainDoubt: {
      value: '',
      error: false,
    },
  });

  const goToSchedule = useCallback(() => {
    history.push('/appointments/new');
  }, [history]);

  useEffect(() => {
    const { timeTableId, columnDate, professionalId } = newAppointmentInfos;
    if (!timeTableId || !columnDate || !professionalId) {
      goToSchedule();
    }
  }, [goToSchedule, newAppointmentInfos]);

  const handleChangeInput = useCallback((e, input) => {
    const { value } = e.target;
    setInformationsValues(oldInformationsValues => ({
      ...oldInformationsValues,
      [input]: {
        value,
        error: false,
      },
    }));
  }, []);

  const checkFormIsValid = useCallback(() => {
    let formIsValid = true;
    setInformationsValues(oldInformationsValues => {
      const informationsValuesArr = convertObjToArr(oldInformationsValues);
      const keysInputs = Object.keys(oldInformationsValues);
      const informations = informationsValuesArr.map((input, index) => {
        const { value } = input;
        if (!value && formIsValid) {
          formIsValid = false;
        }
        const key = keysInputs[index];
        const newObj = {
          value,
          error: !input.value,
          key,
        };
        return newObj;
      });
      const manipulator = item => {
        const manipulatedItem = { ...item };
        delete manipulatedItem.key;
        return manipulatedItem;
      };
      const informationsValided = convertArrToObj(
        informations,
        'key',
        manipulator,
      );
      return informationsValided;
    });
    return formIsValid;
  }, []);

  const handleNextStep = useCallback(() => {
    const formIsValid = checkFormIsValid();
    if (formIsValid) {
      setNewAppointmentInfos(oldInfos => ({
        ...oldInfos,
        contact: informationsValues.contact.value,
        mainDoubt: informationsValues.mainDoubt.value,
      }));
      history.push('/appointments/new/confirmation');
    }
  }, [
    checkFormIsValid,
    history,
    informationsValues.contact.value,
    informationsValues.mainDoubt.value,
    setNewAppointmentInfos,
  ]);

  return (
    <Box className={classes.container}>
      <Box className="informations-header">
        <Typography>Complete as informações:</Typography>
      </Box>
      <Box className="informations-body">
        <TextField
          error={!!informationsValues.contact.error}
          value={informationsValues.contact.value}
          onChange={e => handleChangeInput(e, 'contact')}
          label="Contato para comunicação"
          helperText={
            informationsValues.contact.error && 'Preenchimento obrigatório.'
          }
          placeholder="Ex: Telefone, WhatsApp, e-mail..."
          variant="outlined"
          className="informations-input"
        />
        <TextField
          error={!!informationsValues.mainDoubt.error}
          value={informationsValues.mainDoubt.value}
          onChange={e => handleChangeInput(e, 'mainDoubt')}
          label="Principal dúvida"
          helperText={
            informationsValues.mainDoubt.error && 'Preenchimento obrigatório.'
          }
          placeholder="Escreva um resumo do principal assunto a ser abordado..."
          variant="outlined"
          multiline
          className="informations-textarea"
          InputProps={{ classes: { root: classes.input } }}
        />
      </Box>
      <Box className="informations-footer">
        <Button onClick={goToSchedule}>Trocar horário</Button>
        <Button
          onClick={handleNextStep}
          color="primary"
          className="informations-btn-next"
        >
          Prosseguir
        </Button>
      </Box>
    </Box>
  );
};

export default memo(Informations);
